import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Table } from 'semantic-ui-react'
import Modal from '~/common/modal'
import Api from '~/api'

class InvoiceInfo extends Component {
  state = {
    error: false,
  }

  componentDidMount() {
    let { interviewId, updateInfo } = this.props

    Api.get(`/interview/${interviewId}/invoice`)
      .then(({ data }) => {
        if (!data.success) throw data.message

        updateInfo(fromJS(data.info))
      })
      .catch(err => {
        console.log(err)
        this.setState({
          error: err.message,
        })
      })
  }

  render() {
    let { info, sending, invoiceError, invoiceSuccess } = this.props
    let { error } = this.state

    if (error || invoiceError) return <div className="modal-content-inner">Virhe! {error || invoiceError}</div>

    if (!info) return <div className="modal-content-inner">Ladataan...</div>

    let rows = info.get('rows', List())
    let orders = info.get('orders', List())

    return (
      <div>
        <div className="modal-header">Luo uusi lasku</div>
        <div className="modal-content-inner">
          <div style={{ paddingBottom: '10px' }}>
            <b>{`Laskun nimi: `}</b>
            <span>{info.get('invoice_name')}</span>
          </div>
          <div>
            <b>{`Tilaukset: `}</b>
            <span>{orders.map(o => `${o.get('name')} (${o.get('contract_id')})`).join(', ')}</span>
          </div>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell content="Tuote" />
                <Table.HeaderCell content="Alkup. hinta" />
                <Table.HeaderCell content="Alkup. alennus" />
                <Table.HeaderCell content="Laskuttamatta" />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {rows.map(row => {
                return (
                  <Table.Row key={row.get('id')}>
                    <Table.Cell>
                      {row.get('name')}
                      {`${row.get('name')} (${row.get('product_code')})`}
                    </Table.Cell>
                    <Table.Cell>{row.get('original_price')}€</Table.Cell>
                    <Table.Cell>{row.get('original_discount')}%</Table.Cell>
                    <Table.Cell>{row.get('row_price')}€</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
          {sending ? <div>Luodaan laskua...</div> : invoiceSuccess ? <div>Lasku luotu!</div> : null}
        </div>
      </div>
    )
  }
}

export default class CreateInterviewInvoice extends Component {
  state = {
    open: false,
    info: false,
    sending: false,
    error: false,
    success: false,
  }

  createInvoice = () => {
    let { interview } = this.props

    this.setState({
      sending: true,
    })

    Api.post(`/interview/${interview.get('id')}/invoice`)
      .then(({ data }) => {
        this.setState({
          open: data.success ? false : true,
          error: data.success ? false : data.message || 'Virhe luonnissa!',
        })
      })
      .catch(err => {
        console.log(err)
        this.setState({
          error: err.message || err,
          sending: false,
        })
      })
  }

  render() {
    let { open, info, sending, error, success } = this.state
    let { interview } = this.props

    let modalAction = (
      <Button
        content="Luo lasku"
        icon="plus"
        size="tiny"
        color="green"
        disabled={info === false || sending === true}
        loading={sending}
        onClick={e => e.preventDefault() & this.createInvoice()}
      />
    )

    return (
      <div
        style={{
          borderTop: '1px solid #e6e7e8',
          padding: '5px 10px',
        }}>
        <Button
          content="Luo lasku"
          icon="plus"
          size="tiny"
          color="blue"
          onClick={e => e.preventDefault() & this.setState({ open: true })}
        />
        <Modal open={open} onClose={() => this.setState({ open: false })} actions={modalAction}>
          {open ? (
            <InvoiceInfo
              interviewId={interview.get('id')}
              updateInfo={info => this.setState({ info })}
              sending={sending}
              invoiceError={error}
              invoiceSuccess={success}
              info={info}
            />
          ) : null}
        </Modal>
      </div>
    )
  }
}
